<template lang="pug">
  div
    slot(
      :selected-cities="selectedCities"
      :selected-sectors="selectedSectors"
      :selected-city-ids="selectedCityIds"
      :selected-sector-ids="selectedSectorIds"
      :add-location="addLocation"
      :remove-location="removeLocation"
    )
</template>

<script>

import { formatCities, formatSectors } from "@utils/locations-helpers"

export default {
  props: {
    initialCities: {
      type: Array,
      default: () => {
        return []
      }
    },

    initialSectors: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data () {
    return {
      selectedCities: formatCities(this.initialCities),
      selectedSectors: formatSectors(this.initialSectors)
    }
  },

  computed: {
    selectedCityIds () {
      return this.selectedCities.map(c => c.id)
    },

    selectedSectorIds () {
      return this.selectedSectors.map(c => c.id)
    }
  },

  methods: {
    addLocation (location) {
      if (location.type === "Sector") {
        this.selectedSectors = [
          ...this.selectedSectors,
          location
        ]
      } else {
        this.selectedCities = [
          ...this.selectedCities,
          location
        ]
      }
    },

    removeLocation (location) {
      if (location.type === "Sector") {
        this.selectedSectors = this.selectedSectors.filter(l => l.id !== location.id)
      } else {
        this.selectedCities = this.selectedCities.filter(l => l.id !== location.id)
      }
    }
  }
}
</script>
